import React from 'react';
import { EmployeePageLayout } from '../core/EmployeePageLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock } from 'lucide-react';

interface EmployeeTimeCalendarProps {
  onBack?: () => void;
}

export const EmployeeTimeCalendar: React.FC<EmployeeTimeCalendarProps> = ({ onBack }) => {
  return (
    <EmployeePageLayout
      title="Time & Attendance"
      subtitle="Track employee time and attendance"
      onBack={onBack}
    >
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Clock className="h-5 w-5" />
            Time & Attendance Calendar
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Time and attendance tracking will be implemented here.
          </p>
        </CardContent>
      </Card>
    </EmployeePageLayout>
  );
};